export default __webpack_public_path__ + "5bebfbd2bd67e2216c8ffe0b068ab2ce.png";